import * as ActionTypes from "constants/ActionTypes";

export const setScreenDimensions = (dimensions) => ({
  type: ActionTypes.SET_SCREEN_DIMENSIONS,
  dimensions,
});

export const setUserAgent = (userAgent) => ({
  type: ActionTypes.SET_USERAGENT,
  userAgent,
});

export const setBrowserLanguages = (languages) => ({
  type: ActionTypes.SET_BROWSER_LANGUAGES,
  languages,
});
